export const SEARCH_CAUSES = 'sagas/search/SEARCH_CAUSES';
export const SEARCH_CLIENTS = 'sagas/search/SEARCH_CLIENTS';
export const SEARCH_SOCIETIES = 'sagas/search/SEARCH_SOCIETIES';